var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"paimingk"},[_c('div',{ref:"myChart6",staticStyle:{"width":"320px","height":"400px"}}),_c('div',{ref:"myChart7",staticStyle:{"width":"228px","height":"400px"}}),_c('div',{ref:"myChart8",staticStyle:{"width":"228px","height":"400px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }